import { Video } from 'expo-av';
import React, { useLayoutEffect } from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { palettes } from '../../../../config';
import { useIsSpecificViewportWidth } from '../../../../hooks/useIsSpecificViewportWidth';
import { useAppSelector } from '../../../../redux/store';
import ModalComponent from '../../../common/modal/ModalComponent';

const ContactVideoMessage = ({
	message,
	usersTyping,
}: {
	message: { message: string };
	usersTyping?: string[];
}) => {
	const { isLessThanDesktopBase } = useIsSpecificViewportWidth();

	const chat = useAppSelector(state => state.chat.chat);

	const video = React.useRef(null);

	useLayoutEffect(() => {
		document.querySelector('video') &&
			document
				.querySelector('video')
				?.setAttribute(
					'style',
					`height: ${
						isLessThanDesktopBase ? '100vh' : '75vh'
					}; object-fit: cover;`
				);
	}, [message]);
	return (
		<>
			{/* <ModalComponent
				type="modal"
				header="Image"
				openState={true}
				onClose={() => null}
			>
				<Image
					style={[
						styles.largeImage,
						isLessThanDesktopBase && styles.mobileSizeImage,
					]}
					source={{
						uri: message.message,
					}}
				/>
			</ModalComponent> */}
			<View style={styles.flex1}>
				<Image
					style={styles.profileImage}
					source={{
						uri: chat?.contactPerson?.personalInformation
							?.profileImageLink,
					}}
				/>
				<Video
					ref={video}
					style={[
						styles.video,
						{
							display: 'flex',
							justifyContent: 'center',
						},
					]}
					source={{
						uri: message.message,
					}}
					useNativeControls
					resizeMode="stretch"
					isLooping
					// shouldPlay={true}
				/>
			</View>
		</>
	);
};

const styles = StyleSheet.create({
	flex1: {
		flexDirection: 'row',
		marginTop: 15,
		height: 150,
		justifyContent: 'flex-start',
	},
	profileImage: {
		width: 30,
		height: 30,
		marginRight: 20,
		borderRadius: 25,
	},
	video: {
		width: '30%',
		height: '100%',
		borderRadius: 6,
		marginBottom: 10,
		cursor: 'pointer',
	},
	detailImage: {
		width: 224,
		height: 204,
	},
	mobileSizeImage: {
		width: 159,
		height: 126,
	},
	mobileSizeDetailImage: {
		width: 324,
		height: 304,
	},
});

export default ContactVideoMessage;
